module.exports = __webpack_public_path__ + "img/1.fdbab39e.jpg";